import React from 'react';
import moment from "moment";

import { Grid } from '@material-ui/core';

import NonFieldErrors from '../../../../../components/AssetModal/components/NonFieldErrors';
import {decimalStrToNumber} from "../../../../../utils/utils";
import SelectFormElementV2
  from "../../../../RiskProfiling/components/StepContent/components/formElement/SelectFormElementV2";
import InputFormElement
  , {CurrencyNumberFormat} from "../../../../RiskProfiling/components/StepContent/components/formElement/InputFormElement";
import {LIQUID_ASSETS_CATEGORY, newDesignInputCustomClassesViewOnly} from "../../../constants";
import CalendarFormElement
  from "../../../../RiskProfiling/components/StepContent/components/formElement/CalendarFormElement";
import {newDesignInputCustomClasses} from "../../../../RiskProfiling/constants";
import {choiceValue, dateToMoment, momentToDate} from "../../utils";


const LiquidAssetsForm = (props) => {

  const {
    handleFormChange,
    defaults,
    errors,
    viewOnly
  } = props;

  const [model, setModel] = React.useState({
    sub_category: choiceValue(defaults.sub_category),
    name: defaults.name,
    value: decimalStrToNumber(defaults.value),
    value_date: dateToMoment(defaults.value_date),
    updated: dateToMoment(defaults.updated),
  });

  React.useEffect(() => {
    handleFormChange && handleFormChange({
      ...model,
      value_date: momentToDate(model.value_date),
    });
  }, [model]);

  const handleModelChange = (field) => (value) => {
    setModel({
      ...model,
      [field]: value
    })
  };

  const inputClasses = viewOnly ? newDesignInputCustomClassesViewOnly : newDesignInputCustomClasses;

  return (
    <>
      {!viewOnly && (
        <Grid item xs={12}>
          <SelectFormElementV2
            label="Kategorie"
            error={errors.sub_category}
            value={model.sub_category}
            options={LIQUID_ASSETS_CATEGORY.subCategories}
            onChange={handleModelChange('sub_category')}
            dataId={'category-input'}
            disabled={viewOnly}
            required
            newDesign
          />
        </Grid>
      )}
      <Grid item xs={12} sm={6}>
        <InputFormElement
          label={'Name / Bezeichnung'}
          required={!viewOnly}
          value={model.name}
          error={errors.name}
          onChange={handleModelChange('name')}
          dataId={'name-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputFormElement
          label="Betrag"
          inputComponent={CurrencyNumberFormat}
          inputProps={{inputProps: {allowNegative: false}}}
          value={model.value}
          error={errors.value}
          onChange={handleModelChange('value')}
          dataId={'value-input'}
          required={!viewOnly}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <CalendarFormElement
          label="Erwerbsdatum"
          value={model.value_date}
          error={errors.value_date}
          onChange={handleModelChange('value_date')}
          dataId={'acquisition_date-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <CalendarFormElement
          label="Stand vom"
          value={model.updated || moment()}
          dataId={'updated-input'}
          disabled
          required={!viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      {!!errors['non_field_errors'] && <NonFieldErrors errors={errors['non_field_errors']}/>}
    </>
  )
};

LiquidAssetsForm.defaultProps = {
  defaults: {},
  errors: {}
};

export default LiquidAssetsForm;